import * as yup from 'yup'

export const SignUpValidationScheme = yup.object().shape({
  email: yup
    .string()
    .email('Email Address is invalid')
    .max(100)
    .required('The field is required'),
  password: yup
    .string()
    .required('The field is required')
    .min(8, 'Password requires minimum 8 characters')
    .max(128, 'Password requires maximum 128 characters')
    .test(
      'not-only-spaces',
      'Password cannot contain only blank spaces',
      (value) => typeof value === 'string' && value.trim().length > 0
    ),
  confirmPassword: yup
    .string()
    .when('password', {
      is: (password) => (!!(password && password.length > 0)),
      then: yup.string().oneOf([yup.ref('password')], 'Passwords do not match')
    })
    .required('The field is required')
})
